export const unitPlurals: { [key: string]: string } = {
  // Length
  inch: "inches",
  foot: "feet",
  meter: "meters",
  centimeter: "centimeters",
  yard: "yards",
  mile: "miles",
  league: "leagues",
  rod: "rods",
  furlong: "furlongs",
  "roman foot": "roman feet",
  cubit: "cubits",
  hand: "hands",
  span: "spans",
  palm: "palms",
  chain: "chains",
  morgen: "morgen",
  hide: "hides",

  // Weight
  pound: "pounds",
  ounce: "ounces",
  stone: "stone",
  grain: "grains",
  dram: "drams",
  hundredweight: "hundredweight",
  kilogram: "kilograms",
  ton: "tons",
  gram: "grams",
  carat: "carats",
  talent: "talents",
  shekel: "shekels",

  // Volume
  gallon: "gallons",
  quart: "quarts",
  pint: "pints",
  "fluid ounce": "fluid ounces",
  gill: "gills",
  bushel: "bushels",
  liter: "liters",
  "cubic meter": "cubic meters",
  hogshead: "hogsheads",
  firkin: "firkins",
  butt: "butts",
  peck: "pecks",
  pottle: "pottles",

  // Time
  second: "seconds",
  minute: "minutes",
  hour: "hours",
  day: "days",
  week: "weeks",
  month: "months",
  year: "years",
  fortnight: "fortnights",
  moment: "moments",
  jiffy: "jiffies",

  // Area
  "square meter": "square meters",
  acre: "acres",
  hectare: "hectares",
  "square kilometer": "square kilometers",
  "square mile": "square miles",
  barn: "barns",

  // Speed
  "meters per second": "meters per second",
  "miles per hour": "miles per hour",
  "kilometers per hour": "kilometers per hour",
  knot: "knots",
  "furlong per fortnight": "furlongs per fortnight"
};

const temperatureUnits = ['celsius', 'fahrenheit', 'kelvin', 'reaumur', 'rankine'];

export const getPlural = (unit: string): string => {
  // Handle null/undefined cases
  if (!unit) return '';
  
  // Trim any whitespace
  const trimmedUnit = unit.trim().toLowerCase();
  
  // Special case: temperature units don't get pluralized
  if (temperatureUnits.includes(trimmedUnit)) {
    return trimmedUnit;
  }
  
  // Return plural form if it exists in the mapping
  if (unitPlurals[trimmedUnit]) {
    return unitPlurals[trimmedUnit];
  }
  
  // Default pluralization: add 's' if not found in mapping
  return `${trimmedUnit}s`;
};
